import React from 'react';

const Github = () => (
  <svg
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <path
        className="semiCircle"
        fill="#c0392b"
        d="M12,1c6.075,0,11,4.925,11,11s-4.925,11-11,11S1,18.075,1,12S5.925,1,12,1"
      />
      <path
        fill="#FFFFFF"
        d="M14.313,18.941c0-0.283,0.01-1.207,0.01-2.355c0-0.8-0.273-1.322-0.582-1.588
            c1.911-0.213,3.918-0.938,3.918-4.233c0-0.937-0.332-1.702-0.883-2.303c0.089-0.216,0.383-1.089-0.084-2.271
            c0,0-0.72-0.23-2.357,0.879c-0.686-0.19-1.42-0.285-2.149-0.289c-0.729,0.003-1.463,0.099-2.147,0.289
            c-1.64-1.11-2.36-0.879-2.36-0.879C7.211,7.373,7.505,8.245,7.594,8.461C7.045,9.063,6.71,9.828,6.71,10.765
            c0,3.287,2.003,4.022,3.909,4.239c-0.246,0.215-0.468,0.594-0.545,1.148c-0.489,0.219-1.731,0.598-2.497-0.714
            c0,0-0.454-0.823-1.315-0.884c0,0-0.837-0.012-0.059,0.521c0,0,0.563,0.264,0.953,1.256c0,0,0.504,1.531,2.891,1.012
            c0.004,0.717,0.012,1.393,0.012,1.598l-0.051,0.215c0.738,0.225,1.52,0.348,2.33,0.348c0.717,0,1.413-0.097,2.074-0.274
            C14.342,19.147,14.313,19.041,14.313,18.941"
      />
      <path
        fill="#E9E8E8"
        d="M4.222,19.778L4.222,19.778c0.443,0.442,0.923,0.848,1.436,1.21C5.145,20.626,4.665,20.221,4.222,19.778
            M19.778,4.222L19.778,4.222c0.443,0.443,0.849,0.924,1.211,1.438C20.627,5.146,20.222,4.665,19.778,4.222"
      />
      <path
        className="semiCircle"
        fill="#c0392b"
        d="M9.267,14.732l-1.25,1.25c0.343,0.298,0.725,0.395,1.075,0.395c0.403,0,0.766-0.128,0.981-0.225
            c0.077-0.555,0.299-0.934,0.545-1.148C10.165,14.952,9.705,14.871,9.267,14.732 M19.778,4.222l-2.855,2.855
            c0.091,0.721-0.083,1.227-0.147,1.384c0.551,0.601,0.883,1.366,0.883,2.303c0,3.295-2.007,4.021-3.918,4.233
            c0.309,0.266,0.582,0.788,0.582,1.588c0,1.148-0.01,2.072-0.01,2.355c0,0.1,0.029,0.206,0.099,0.288
            c-0.661,0.178-1.356,0.274-2.074,0.274c-0.81,0-1.592-0.123-2.33-0.348l0.051-0.215c0-0.205-0.008-0.881-0.012-1.598
            c-0.346,0.075-0.653,0.107-0.924,0.107c-1.024,0-1.543-0.46-1.784-0.79l-3.117,3.117c0.443,0.442,0.923,0.848,1.436,1.21
            C7.45,22.256,9.638,23,12,23c6.075,0,11-4.925,11-11c0-0.019,0-0.039,0-0.058c-0.012-2.339-0.755-4.506-2.011-6.283
            C20.627,5.146,20.222,4.665,19.778,4.222"
      />
      <path
        fill="#E9E8E8"
        d="M16.923,7.077l-7.656,7.655c0.438,0.139,0.897,0.22,1.352,0.271c-0.246,0.215-0.468,0.594-0.545,1.148
            c-0.216,0.097-0.578,0.225-0.981,0.225c-0.351,0-0.732-0.097-1.075-0.395l-0.679,0.679c0.241,0.33,0.76,0.79,1.784,0.79
            c0.271,0,0.578-0.032,0.924-0.107c0.004,0.717,0.012,1.393,0.012,1.598l-0.051,0.215c0.738,0.225,1.52,0.348,2.33,0.348
            c0.717,0,1.413-0.097,2.074-0.274c-0.069-0.082-0.099-0.188-0.099-0.288c0-0.283,0.01-1.207,0.01-2.355
            c0-0.8-0.273-1.322-0.582-1.588c1.911-0.213,3.918-0.938,3.918-4.233c0-0.937-0.332-1.702-0.883-2.303
            C16.84,8.304,17.014,7.798,16.923,7.077"
      />
    </g>
  </svg>
);

export default Github;
